module.exports = __webpack_public_path__ + "bdcfcfac2b678385ba85fbb4f7a06f41.pdf";